import React from 'react';
import UpdateEmailLayout from '../../components/update-email/UpdateEmailLayout';
import UpdateEmailNew from '../../components/update-email/UpdateEmailNew';

const UpdateEmailNewPage = (props) => (
  <UpdateEmailLayout>
    <UpdateEmailNew {...props} />
  </UpdateEmailLayout>
);

export default UpdateEmailNewPage;
